function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "m120 336a32 32 0 1 0 32 32 32.036 32.036 0 0 0 -32-32zm0 48a16 16 0 1 1 16-16 16.019 16.019 0 0 1 -16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 336a32 32 0 1 0 32 32 32.036 32.036 0 0 0 -32-32zm0 48a16 16 0 1 1 16-16 16.019 16.019 0 0 1 -16 16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168 344h176v16h-176z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m168 376h176v16h-176z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m480 160h-24v-88a56.063 56.063 0 0 0 -56-56h-288a56.063 56.063 0 0 0 -56 56v32h192v192h-63.637l31.637-35.153v19.153h16v-80h-16v36.93l-53.163 59.07h-90.837v-176h-16v40h-24a16.019 16.019 0 0 0 -16 16v80a16.019 16.019 0 0 0 16 16h24v136a24.039 24.039 0 0 0 16 22.624v49.376a16.019 16.019 0 0 0 16 16h48a16.019 16.019 0 0 0 16-16v-48h272v48h-48v-32h-16v32a16.019 16.019 0 0 0 16 16h48a16.019 16.019 0 0 0 16-16v-49.376a24.039 24.039 0 0 0 16-22.624v-136h24a16.019 16.019 0 0 0 16-16v-80a16.019 16.019 0 0 0 -16-16zm-408-88a40.045 40.045 0 0 1 40-40h288a40.045 40.045 0 0 1 40 40v16h-368zm192 32h176v192h-90.837l-53.163-59.07v-36.93h-16v80h16v-19.153l31.637 35.153h-63.637zm-232 152v-80h24v80zm104 224h-48v-48h48zm296-64h-352a8.009 8.009 0 0 1 -8-8v-96h76.437l-2.383 2.648 11.892 10.7 12.017-13.348h172.074l12.017 13.352 11.892-10.7-2.383-2.652h76.437v96a8.009 8.009 0 0 1 -8 8zm48-160h-24v-80h24l.01 80z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m248 48h16v16h-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m280 48h16v16h-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m216 48h16v16h-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m104 48h16v16h-16z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m392 48h16v16h-16z"
}));

var SvgPublicTransport = function SvgPublicTransport(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "50px",
    viewBox: "0 0 512 512",
    width: "50px",
    fill: "#ffffff",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPublicTransport, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/public-transport.9789110e.svg";
export { ForwardRef as ReactComponent };